import { config } from '../apiConfig';

const WalletReportExport = async (parameters) => {
    document.location.href = `${config.url}/api/mvc/export/WalletReportExport?TransType=${parameters.TransType}&DocType=${parameters.DocType}&StartDate=${parameters.StartDate}&EndDate=${parameters.EndDate}`;
}

export default WalletReportExport;